import React, { useState } from "react";

import "./Contact.scss";

export const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((current) => ({
      ...current,
      [name]: value
    }));
  };

  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setStatus(null);

    try {
      const response = await fetch(`${API_URL}/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Unable to send message.");
      }

      setStatus("success");

      setFormData({
        fullName: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      });
    } catch (error) {
      console.error(error);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="modern-contact" id="contact">
      <div className="modern-contact-inner">
        <div className="contact-meta">
          <span>07</span>

          <small>CONTACT</small>
        </div>

        <div className="contact-layout">
          <div className="contact-copy">
            <h2>
              LET'S CREATE
              <span>SOMETHING REAL.</span>
            </h2>

            <p>
              Collaborations, bookings, partnerships, media and creative ideas.
              If you have something worth building, start the conversation.
            </p>

            <div className="contact-types">
              <div>
                <small>01</small>
                <span>BOOKINGS</span>
              </div>

              <div>
                <small>02</small>
                <span>COLLABORATIONS</span>
              </div>

              <div>
                <small>03</small>
                <span>BUSINESS</span>
              </div>
            </div>
          </div>

          <form className="modern-contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <label>
                <span>YOUR NAME</span>

                <input
                  type="text"
                  name="fullName"
                  placeholder="Adam"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                <span>EMAIL</span>

                <input
                  type="email"
                  name="email"
                  placeholder="hello@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </label>
            </div>

            <div className="form-row">
              <label>
                <span>PHONE</span>

                <input
                  type="tel"
                  name="phone"
                  placeholder="+212..."
                  value={formData.phone}
                  onChange={handleChange}
                />
              </label>

              <label>
                <span>SUBJECT</span>

                <input
                  type="text"
                  name="subject"
                  placeholder="Collaboration"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </label>
            </div>

            <label className="message-field">
              <span>YOUR MESSAGE</span>

              <textarea
                name="message"
                placeholder="Tell us about your idea..."
                value={formData.message}
                onChange={handleChange}
                required
              />
            </label>

            <div className="contact-submit-row">
              <button type="submit" disabled={loading}>
                {loading ? "SENDING..." : "SEND MESSAGE"}

                {!loading && <span>↗</span>}
              </button>

              {status === "success" && (
                <p className="contact-success">Message sent successfully.</p>
              )}

              {status === "error" && (
                <p className="contact-error">
                  Something went wrong. Please try again.
                </p>
              )}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};
